<div class="timezone">
  <mat-form-field class="timezone__field" appearance="outline">
    <mat-label>Timezone</mat-label>
    <input
      #timezoneInput
      type="text"
      matInput
      [disabled]="disabled()"
      [required]="required()"
      [formControl]="control()"
      [matAutocomplete]="auto"
      (keydown.enter)="selectOption()"
    />
    <mat-autocomplete #auto="matAutocomplete" #timezoneAutocomplete>
      @if (!control()?.value) {
        <mat-option value=""></mat-option>
      }
      @for (timezone of filteredOptions; track timezone) {
        <mat-option [value]="timezone.value">
          {{ timezone.value }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  @if (control()?.value) {
    <button
      mat-icon-button
      (click)="onClickRemove()"
      class="timezone__close"
      color="warn"
      matTooltip="Remove"
      [disabled]="disabled()"
    >
      <mat-icon>close </mat-icon>
    </button>
  }
</div>
